export const MESSAGES_SOURCE = {
    MAIN_PROXY: 'mainProxy',
    FIREBASE: 'firebase'
}
export const KICK_TYPE = {
    FULL_KICK: '1',
    SOFT_KICK: '2'
};

export const KICK_REASON = {
    // full kick
    KickUserAlreadyLoggedIn: '20',
    KickUserMobileLocation: '21',
    KickUserNoWiFi: '23',
    KickUserRDPDetected: '24',
    KickUserOutsideCountry: '25',
    KickUserTechProblem: '26',
    KickUserPluginNotInstalled: '27',
    KickUserPluginNotUpdated: '28',
    KickUserLocationProcessTimeOut: '29',
    KickUserWagerMobileFailed: '31',
    KickUserOptInError: '32',
    KickUserNetworkSwitch: '33',
    KickUserGCTimeout: '34',
    KickUserLocationDisabled: '35',
    KickUserKnownProxy: '36',
    KickUserRestrictedPlay: '50',
    KickUserPendingAction: '51',
    // soft kick
    KickUserDailyReached: '30',
    KickUserWeeklyReached: '39',
    KickUserMonthlyReached: '40',
    KickUserUkNightLimit: '60'
};

export const KICK_REASONS = [
    KICK_REASON.KickUserAlreadyLoggedIn,
    KICK_REASON.KickUserMobileLocation,
    KICK_REASON.KickUserNoWiFi,
    KICK_REASON.KickUserRDPDetected,
    KICK_REASON.KickUserOutsideCountry,
    KICK_REASON.KickUserTechProblem,
    KICK_REASON.KickUserPluginNotInstalled,
    KICK_REASON.KickUserPluginNotUpdated,
    KICK_REASON.KickUserLocationProcessTimeOut,
    KICK_REASON.KickUserWagerMobileFailed,
    KICK_REASON.KickUserOptInError,
    KICK_REASON.KickUserNetworkSwitch,
    KICK_REASON.KickUserGCTimeout,
    KICK_REASON.KickUserLocationDisabled,
    KICK_REASON.KickUserKnownProxy,
    KICK_REASON.KickUserRestrictedPlay,
    KICK_REASON.KickUserPendingAction,
    KICK_REASON.KickUserDailyReached,
    KICK_REASON.KickUserWeeklyReached,
    KICK_REASON.KickUserMonthlyReached
];
export const GEO_LOCATION_KICK_REASONS = [
    KICK_REASON.KickUserMobileLocation,
    KICK_REASON.KickUserNoWiFi,
    KICK_REASON.KickUserRDPDetected,
    KICK_REASON.KickUserOutsideCountry,
    KICK_REASON.KickUserTechProblem,
    KICK_REASON.KickUserPluginNotInstalled,
    KICK_REASON.KickUserPluginNotUpdated,
    KICK_REASON.KickUserLocationProcessTimeOut,
    KICK_REASON.KickUserWagerMobileFailed,
    KICK_REASON.KickUserOptInError,
    KICK_REASON.KickUserNetworkSwitch,
    KICK_REASON.KickUserGCTimeout,
    KICK_REASON.KickUserLocationDisabled,
    KICK_REASON.KickUserKnownProxy
];